import * as UI from "@iyk/ui"
import * as React from "react"

import { Analytics, useAnalytics } from "@iyk/vf-observability/react"
import { Sheet } from "./sheet.tsx"

export const HowToTapDialog = ({
  open,
  setOpen,
  image
}: {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  image: string
}) => {
  const analytics = useAnalytics()

  const handleOpenChange = (open: boolean) => {
    if (open) analytics.track(Analytics.Event.HowToTapViewed())
    setOpen(open)
  }

  return (
    <Sheet.Root open={open} onOpenChange={handleOpenChange}>
      <Sheet.Trigger className="relative flex items-center justify-between border border-white/[10%] bg-white/[3%] rounded p-3 overflow-hidden">
        <span className="uppercase text-xs font-departure-mono text-left">
          Did you know your VIP lanyard <br /> gives you access to rewards?
        </span>
        <UI.Icon.InfoCircled />
      </Sheet.Trigger>
      <Sheet.Content
        title="Did you know your VIP lanyard gives you access to rewards?"
        description="Tap your card to access bonus content and other Unlocks."
      >
        <div className="flex flex-col gap-6 px-4 py-8">
          <h3 className="text-xl">Did you know your VIP lanyard gives you access to rewards?</h3>
          <img src={image} className="size-full aspect-video" alt="How to tap your VIP lanyard" />
          <p className="text-sm">Tap your card to access bonus content and other Unlocks.</p>
          <UI.Button
            type="button"
            kind="solid"
            size="lg"
            className="w-full"
            onClick={() => handleOpenChange(false)}
          >
            Got it
          </UI.Button>
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}
